module.exports = new __parcel__URL__("navbar-logo.69e0fa4a.jpeg").toString();